import { DRAWER_CONTEXT } from "@models/DrawerContext";

/**
 * URL ⇆ drawer mapping. The drawer's open/edit/prefill state lives in the page's
 * search params so it is shareable, refresh-safe, and closable with the browser
 * Back button. The `drawer` param value is the kebab-case form of the
 * DRAWER_CONTEXT enum (e.g. `?drawer=edit-product`).
 */
export const DRAWER_PARAM = "drawer";
export const DRAWER_ID_PARAM = "id";
export const DRAWER_PREFILL_PRODUCT_PARAM = "prefillProduct";
export const DRAWER_PREFILL_LOCATION_PARAM = "prefillLocation";

const toParam = (context: DRAWER_CONTEXT): string =>
  context.toLowerCase().replace(/_/g, "-");

const PARAM_TO_CONTEXT: Record<string, DRAWER_CONTEXT> = Object.fromEntries(
  Object.values(DRAWER_CONTEXT).map((context) => [toParam(context), context])
);

export function contextToParam(context: DRAWER_CONTEXT): string {
  return toParam(context);
}

export function paramToContext(value: string | null): DRAWER_CONTEXT | null {
  if (!value) return null;
  return PARAM_TO_CONTEXT[value] ?? null;
}
